<template>
  <div :class="className"
       :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data () {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        // this.setOptions(val);
      },
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy () {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$el, "macarons");
      // this.setOptions(this.chartData || {});
    },
    setOptions (data) {
      let _this = this;
      let setOptionStyle = {
        tooltip: {
          trigger: "axis",
          backgroundColor: 'rgba(255,255,255,1)'
        },
        legend: {
          data: ["新增数", "完成数"],
          right: 0,
          textStyle: {
            color: _this.isbig ? "#AABEFF" : "",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },

        xAxis: {
          show: true,
          type: "category",
          // boundaryGap: false,
          data: data.xAxisData,
        },
        yAxis: {
          type: "value",
          splitArea: {
            show: false,
          },
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "#333",
          },
          splitLine: {
            lineStyle: {
              color: _this.isbig ? "#1A48DD" : "#ddd",
            },
          },
        },
        series: [
          {
            name: "新增数",
            type: "line",
            stack: "总量",
            data: [120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90, 230, 210],
            smooth: 0,
          },
          {
            name: "完成数",
            type: "line",
            stack: "总量",
            data: [220, 182, 191, 234, 290, 330, 310, 120, 132, 101, 134, 90, 230, 210],
            smooth: 0,
          },
        ],
      }
      setOptionStyle.series = []
      for (var key in data.seriesList) {
        let seriesList = {
          name: "新增数",
          type: "line",
          stack: "总量",
          data: [36, 186, 1154],
          smooth: 0,
        }
        seriesList.name = data.seriesList[key].name;
        seriesList.data = data.seriesList[key].data;
        setOptionStyle.series.push(seriesList);
      }
      this.chart.setOption(setOptionStyle);
    },
  },
};
</script>
